<template>
  <section class="section-content">
    <div class="back-button" @click="goToHome">
      <svg xmlns="http://www.w3.org/2000/svg" width="7" height="15" viewBox="0 0 7 15" fill="none">
        <path d="M6 0.500122L1 7.50012L6 14.5001" stroke="#464D5B" />
      </svg>
      <span class="back-text">Recetas</span>
    </div>
    <div class="separator-line mobile"></div>
    <div class="program-image desktop">
      <h1 class="program-title">Recetas</h1>
    </div>
    <div class="search-container">
      <div class="search-bar">
        <searchBar />
      </div>
      <div class="search-details desktop">
        <span class="search-info" v-if="$route.query.search">Mostrando resultados de busqueda "{{
          deNormalizeText($route.query.search)
        }}"</span>
        <span class="search-info" v-else-if="$route.query.c">Mostrando "{{ deNormalizeText($route.query.cN)
          }}"</span>

        <span class="search-info" v-else>Mostrando todas las clases</span>
        <span class="search-info">{{ allRecetas.quantity }} recetas encontradas</span>

      </div>
    </div>
    <div class="content-wrapper ">
      <div class="left-section">
        <div class="below-search">
          <h2 class="main-title desktop">Categorías</h2>
          <div class="button-container">
            <categorias />
          </div>
        </div>
      </div>
      <div class="right-section">
        <div class="section-container">
          <span class="class-title mobile">Últimas recetas</span>
          <section v-if="cumulativeClases" class="cards-wrapper">
            <div @click="openModal(), selectedRecipe = recipes" v-for="recipes in cumulativeClases" :key="recipes.id"
              class="card-container" :class="{ locked: recipes.locked }">
              <div class="image-container">
                <img v-if="recipes.webImg" :src="srcRecipeImg(recipes.id, recipes.webImg)" class="card-image" />
                <img v-else src="@/assets/PlanAlimImg2.jpg" alt="Clase Principiante" class="card-image" />
              </div>
              <div class="content-container">
                <div class="content-header">
                  <h3 class="card-title">{{ recipes.title }}</h3>
                  <!-- <span class="like-button" @click.stop="toggleLike">
                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
                      <mask id="mask0_4_125" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="38"
                        height="38">
                        <rect width="37.7143" height="37.7143" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_4_125)">
                        <path
                          d="M18.8572 31.942L17.1227 30.3828C14.5178 28.0196 12.3636 25.9889 10.6602 24.2907C8.95677 22.5923 7.60691 21.0807 6.61063 19.756C5.61434 18.4315 4.91833 17.2232 4.52259 16.1311C4.12659 15.0392 3.92859 13.9312 3.92859 12.8071C3.92859 10.577 4.68052 8.7099 6.18437 7.20578C7.68849 5.70192 9.55561 4.95 11.7857 4.95C13.1576 4.95 14.454 5.27083 15.675 5.9125C16.896 6.55416 17.9567 7.47437 18.8572 8.67311C19.7576 7.47437 20.8183 6.55416 22.0393 5.9125C23.2603 5.27083 24.5567 4.95 25.9286 4.95C28.1587 4.95 30.0258 5.70192 31.5299 7.20578C33.0338 8.7099 33.7857 10.577 33.7857 12.8071C33.7857 13.9312 33.5877 15.0392 33.1917 16.1311C32.796 17.2232 32.1 18.4315 31.1037 19.756C30.1074 21.0807 28.76 22.5923 27.0616 24.2907C25.3634 25.9889 23.2067 28.0196 20.5916 30.3828L18.8572 31.942ZM18.8572 28.7571C21.3714 26.4948 23.4405 24.5557 25.0643 22.9397C26.6881 21.324 27.9714 19.9203 28.9143 18.7287C29.8572 17.537 30.5119 16.4788 30.8786 15.554C31.2453 14.6295 31.4286 13.7139 31.4286 12.8071C31.4286 11.2357 30.9048 9.92619 29.8572 8.87857C28.8095 7.83095 27.5 7.30714 25.9286 7.30714C24.6877 7.30714 23.5408 7.65914 22.4879 8.36314C21.4354 9.0674 20.6018 10.0471 19.9874 11.3021H17.7269C17.1023 10.0368 16.2661 9.0547 15.2185 8.35568C14.1709 7.65665 13.0266 7.30714 11.7857 7.30714C10.2243 7.30714 8.91722 7.83095 7.86462 8.87857C6.81203 9.92619 6.28573 11.2357 6.28573 12.8071C6.28573 13.7139 6.46907 14.6295 6.83573 15.554C7.2024 16.4788 7.85716 17.537 8.80002 18.7287C9.74288 19.9203 11.0262 21.3215 12.65 22.9322C14.2738 24.543 16.3429 26.4846 18.8572 28.7571Z"
                          fill="white" />
                      </g>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
                      <mask id="mask0_4_124" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="38"
                        height="38">
                        <rect width="37.7143" height="37.7143" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_4_124)">
                        <path
                          d="M18.8572 31.942L17.1227 30.3828C14.5178 28.0196 12.3636 25.9889 10.6602 24.2907C8.95677 22.5923 7.60691 21.0807 6.61062 19.756C5.61434 18.4315 4.91833 17.2232 4.52259 16.1311C4.12659 15.0392 3.92859 13.9312 3.92859 12.8071C3.92859 10.577 4.68052 8.7099 6.18437 7.20578C7.68849 5.70193 9.55561 4.95 11.7857 4.95C13.1576 4.95 14.454 5.27083 15.675 5.9125C16.896 6.55416 17.9567 7.47437 18.8572 8.67311C19.7576 7.47437 20.8183 6.55416 22.0393 5.9125C23.2603 5.27083 24.5567 4.95 25.9286 4.95C28.1587 4.95 30.0258 5.70193 31.5299 7.20578C33.0338 8.7099 33.7857 10.577 33.7857 12.8071C33.7857 13.9312 33.5877 15.0392 33.1917 16.1311C32.796 17.2232 32.1 18.4315 31.1037 19.756C30.1074 21.0807 28.76 22.5923 27.0616 24.2907C25.3634 25.9889 23.2067 28.0196 20.5916 30.3828L18.8572 31.942ZM18.8572 28.7571C21.3714 26.4948 23.4405 24.5557 25.0643 22.9397C26.6881 21.324 27.9714 19.9203 28.9143 18.7287C29.8572 17.537 30.5119 16.4788 30.8786 15.554C31.2453 14.6295 31.4286 13.7139 31.4286 12.8071C31.4286 11.2357 30.9048 9.92619 29.8572 8.87857C28.8095 7.83095 27.5 7.30714 25.9286 7.30714C24.6877 7.30714 23.5408 7.65914 22.4879 8.36314C21.4354 9.0674 20.6018 10.0471 19.9874 11.3021H17.7269C17.1023 10.0368 16.2661 9.0547 15.2185 8.35568C14.1709 7.65665 13.0266 7.30714 11.7857 7.30714C10.2243 7.30714 8.91722 7.83095 7.86462 8.87857C6.81203 9.92619 6.28573 11.2357 6.28573 12.8071C6.28573 13.7139 6.46907 14.6295 6.83573 15.554C7.2024 16.4788 7.85716 17.537 8.80002 18.7287C9.74287 19.9203 11.0262 21.3215 12.65 22.9322C14.2738 24.543 16.3429 26.4846 18.8572 28.7571Z"
                          fill="white" />
                        <path
                          d="M18.8572 28.7571C21.3714 26.4948 23.4405 24.5557 25.0643 22.9397C26.6881 21.324 27.9714 19.9203 28.9143 18.7287C29.8572 17.537 30.5119 16.4788 30.8786 15.554C31.2453 14.6295 31.4286 13.7138 31.4286 12.8071C31.4286 11.2357 30.9048 9.92617 29.8572 8.87855C28.8095 7.83093 27.5 7.30712 25.9286 7.30712C24.6877 7.30712 23.5408 7.65913 22.4879 8.36313C21.4354 9.06739 20.6018 10.047 19.9874 11.3021H17.7269C17.1023 10.0368 16.2661 9.05468 15.2185 8.35566C14.1709 7.65664 13.0266 7.30712 11.7857 7.30712C10.2243 7.30712 8.91722 7.83093 7.86462 8.87855C6.81203 9.92617 6.28573 11.2357 6.28573 12.8071C6.28573 13.7138 6.46907 14.6295 6.83573 15.554C7.2024 16.4788 7.85716 17.537 8.80002 18.7287C9.74287 19.9203 11.0262 21.3215 12.65 22.9322C14.2738 24.5429 16.3429 26.4846 18.8572 28.7571Z"
                          fill="#FF3EA6" />
                      </g>
                    </svg>
                  </span> -->
                </div>
                <div class="description">
                  <p v-if="recipes.categories" class="card-description">{{ recipes.categories[0].name }}</p>
                </div>
              </div>
            </div>
          </section>

          <section v-else>
            <span class="class-title">No se encotraron recetas</span>
          </section>

        </div>
      </div>
    </div>
    <recipe-modal v-if="showModal" :recipe="selectedRecipe" :liked.sync="liked" @close="closeModal" />

  </section>
</template>

<script>
import { url } from '../../global/index';

import { mapActions } from 'vuex';
import RecipeModal from "../recipeModal.vue";

import searchBar from "../searchBar.vue";
import categorias from "../categorias.vue";
export default {
  name: "ProgramView",
  components: {
    searchBar,
    categorias,
    RecipeModal,
  },
  data() {
    return {
      actualPage: 1,
      cumulativeClases: [],
      totalClass: 0,
      totalPages: 3,
      showModal: false,
      selectedRecipe: null,
    };
  },
  async created() {
    this.getRecetasInfo();
  },
  computed: {
    allRecetas() {
      const data = this.$store.getters['recetas/data'];
      if (!Array.isArray(data.data) || data.data.length === 0) return [];

      return data;

    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    ...mapActions('recetas', ['getAllInfoRct']),
    openModal() {

      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    goToHome() {
      this.$router.push({ query: { a: "inicio" } });
    },
    async getRecetasInfo() {
      let url = `recipe/paginated?page=${this.actualPage}&pageSize=12`;

      if (this.$route.query.search) {

        url += `&name=${encodeURIComponent(this.$route.query.search)}`;
      }
      if (this.$route.query.c) {
        url += `&categories=${this.$route.query.c}`;
      }

      const response = await this.getAllInfoRct(url);
      console.log(response)
      if (response.data === null) return [];

      this.totalClass = response.data.totalAllProducts
      this.totalPages = response.data.totalPages
      this.cumulativeClases = response.data.data
    },
    async getMoreRecetasInfo() {
      this.actualPage++

      let url = `recipe/paginated?page=${this.actualPage}&pageSize=12`;
      if (this.$route.query.search) {

        url += `&name=${encodeURIComponent(this.$route.query.search)}`;
      }
      if (this.$route.query.c) {
        url += `&categories=${this.$route.query.c}`;
      }


      const response = await this.getAllInfoRct(url);

      const clasesBatch = response.data.data

      this.cumulativeClases = [...this.cumulativeClases, ...clasesBatch]
    },
    handleScroll() {
      if (this.actualPage === this.totalPages) {
        return
      }
      const scrollPosition = window.scrollY + window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // Compara si el usuario está cerca del final de la página
      if (scrollPosition >= documentHeight - 300 && !this.methodCalled) {
        this.methodCalled = true;  // Marca que el método ya ha sido llamado
        this.getMoreRecetasInfo();         // Llama al método cuando está cerca del final
      } else if (scrollPosition < documentHeight - 300 && this.methodCalled) {
        // Restablecer la bandera cuando el usuario vuelve a subir
        this.methodCalled = false;
      }
    },
    async resetClassInfo() {
      this.actualPage = 1;  // Volver a la primera página
      this.cumulativeClases = [];  // Limpiar las clases acumuladas
      this.totalClass = 0;  // Resetear el total de clases
      this.totalPages = 0;  // Resetear las páginas totales
    },
    normalizeText(texto) {
      const normal = texto
        .toLowerCase()
        .replace(/\s+/g, '-');

      return normal;
    },
    deNormalizeText(texto) {
      if (texto) {
        const original = texto.replace(/-/g, ' ')

        return original;
      }
    },
    srcRecipeImg: function (idRec, img) {
      if (!img || img == "") {
        return "";
      }
      let src = `${url}/recipe-image/${idRec}/${img}`;

      return src;
    },
  },
  watch: {
    '$route.query.search': {
      handler(newVal, oldVal) {
        this.resetClassInfo();
        this.getRecetasInfo()
      },
      immediate: true
    },
    '$route.query.c': {
      handler(newVal, oldVal) {
        this.resetClassInfo();
        this.getRecetasInfo()
      },
      immediate: true
    },

  },
};
</script>

<style scoped>
.desktop {
  display: block;
}

.mobile {
  display: none;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.program-container {
  display: flex;
  justify-content: center;
  width: 100%;
}

.program-image {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 22.9167vw;
  border-radius: 1.3889vw;
  background: url("@/assets/PlanAlimImg2.jpg") center -9.7222vw;
  background-size: cover;
  overflow: hidden;
}

.program-title {
  position: absolute;
  font-family: Kemio, sans-serif;
  font-size: 7.6389vw;
  font-style: normal;
  font-weight: 400;
  line-height: 139.195%;
  text-transform: uppercase;
  text-align: center;
  background: var(--gradient-2,
      linear-gradient(90deg, #4536ef 23.52%, #ff00b8 91.32%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  margin: 0;
}

.section-content {
  padding-top: 0;
  margin-top: 0;
}

.main-title,
.description,
.class-title {
  margin-top: 0;
}

.search-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  margin-bottom: 1vw;
}

.search-bar {
  flex: 1;
  width: 26.0833vw;
}

.search-details {
  display: flex;
  gap: 17.3611vw;
  white-space: nowrap;
}

.search-info {
  color: var(--Text, #464d5b);
  font-family: Manrope, sans-serif;
  font-size: 0.9vw;
  font-weight: 600;
  line-height: normal;
}

.button-container {
  width: 100%;
}

.gradient-button {
  display: flex;
  height: 2.5vw;
  padding: 0.5vw 1vw;
  justify-content: space-between;
  align-items: center;
  border-radius: 20vw;
  background: linear-gradient(90deg, #4536ef 23.52%, #ff00b8 91.32%);
  border: none !important;
  color: #fff;
  font-family: Manrope, sans-serif;
  font-size: 1vw;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
}

.button-content {
  display: flex;
  align-items: center;
  gap: 0.5vw;
}

.gradient-button .button-content {
  color: #fff;
  text-align: center;
  font-family: Manrope;
  font-size: 1vw;
  font-weight: 400;
  line-height: normal;
}

.custom-button {
  width: 100%;
  height: 2.7778vw;
  display: flex;
  padding: 0.5vw 1vw;
  justify-content: space-between;
  align-items: center;
  border-radius: 2.0833vw;
  border: 0.0694vw solid var(--background-gray, #e3e3e9);
  background-color: transparent;
  cursor: pointer;
}

.custom-button span {
  color: var(--Text, #464d5b);
  text-align: center;
  font-family: Manrope;
  font-size: 1vw;
  font-weight: 400;
  line-height: normal;
}

.back-button {
  display: flex;
  align-items: center;
  gap: 0.5vw;
  cursor: pointer;
  margin-bottom: 0.5vw;
}

.back-text {
  font-family: Manrope;
  font-size: 1.2vw;
  font-weight: 600;
  color: var(--Text, #464d5b);
}

.back-icon {
  width: 0.5vw;
  height: 1vw;
  stroke: var(--Text, #464d5b);
}

.content-wrapper {
  display: flex;
  gap: 2vw;
  justify-content: space-between;
  align-items: flex-start;
}

.left-section {
  width: 30%;
  display: flex;
  flex-direction: column;
  gap: 1vw;
  position: sticky;
  top: 3.9444vw;
}

.below-search {
  display: flex;
  flex-direction: column;
  gap: 1.5vw;
}

.main-title {
  color: var(--Text, #464d5b);
  font-family: Manrope, sans-serif;
  font-size: 1.7vw;
  font-weight: 400;
  line-height: normal;
  margin-top: 0;
}

.right-section {
  width: 70%;
  display: flex;
  flex-direction: column;
}

.section-container {
  width: 100%;
}

.class-title {
  margin: 0;
  text-align: left;
  color: var(--Text, #464d5b);
  font-family: Manrope;
  font-size: 1.2vw;
  font-weight: 500;
  line-height: normal;
  padding-left: 0.5vw;
  margin-top: 1vw;
}

.cards-wrapper {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1vw;
  padding: 1vw 0;
}

/* card */

.locked {
  filter: grayscale(1) opacity(0.8);
  pointer-events: none;
  user-select: none;
}

.like-button {
  display: flex;
  position: relative;
  flex-direction: row;
  padding-right: 0.6944vw;
}

.like-button svg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: opacity 0.3s ease;
  width: 1.8056vw;
  height: 1.7361vw;
}

.like-active {
  opacity: 0;
}

.card-container {
  position: relative;
  width: 14.7861vw;
  border-radius: 1.0417vw;
  overflow: hidden;
  box-shadow: 0 0.2778vw 0.4167vw rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.description {
  display: flex;
  flex-direction: row;
}

.image-container {
  overflow: hidden;
}

.card-image {
  width: 100%;
  height: 10.972222vw;
  object-fit: cover;
  display: block;
}

.content-container {
  padding: 0.6944vw;
  display: flex;
  flex-direction: column;
  gap: 0.3472vw;
  box-sizing: border-box;
  background: var(--background-gray, #e3e3e9);
}

.card-title {
  color: var(--Text, #464d5b);
  font-family: Manrope;
  font-size: 1.25vw;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 2lh;
}

.card-description {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  align-self: stretch;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: Manrope;
  font-size: 0.8333vw;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  background: var(--gradient-2,
      linear-gradient(90deg, #4536ef 23.52%, #ff00b8 91.32%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.content-header {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  padding: 0 0.6944vw 0 0;
}

@media (max-width: 530px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: block;
  }

  .content-wrapper {
    flex-direction: column;
  }

  .back-button {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    padding-bottom: 5vw;
  }

  .back-text {
    flex-grow: 1;
    text-align: center;
    font-size: 4.5vw;
  }

  .back-icon {
    position: absolute;
    left: 0;
    width: 5vw;
    height: auto;
  }

  .separator-line {
    width: 100%;
    height: 0.0694vw;
    min-height: 0.0694vw;
    background: #e3e3e9;
  }

  .search-bar {
    padding-top: 5vw;
    padding-bottom: 5vw;
    width: 100%;
  }

  .left-section {
    position: relative;
    width: 100%;
  }

  .right-section {
    width: 100%;
  }

  .class-title {
    padding-top: 5vw;
    padding-bottom: 5vw;
    font-size: 5.75vw;
  }

  .cards-wrapper {
    padding-bottom: 10vh;
    gap: 2.5vw;
    grid-template-columns: repeat(2, 1fr);
  }

  .card-container {
    position: relative;
    width: 100%;
    border-radius: 5vw;
  }

  .card-image {
    width: 100%;
    height: 42.75vw;
    transform: scale(1);
    object-fit: cover;
    display: block;
  }

  .content-container {
    padding-left: 2.5vw;
    height: 19vw;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    background: var(--background-gray, #e3e3e9);
  }

  .card-title {
    font-size: 4.5vw;
  }

  .card-description {
    font-size: 2.5vw;
  }

  .like-button {
    padding-right: 5vw;
  }

  .like-button svg {
    position: absolute;
    top: 30%;
    transform: translate(-50%, -50%);
    transition: opacity 0.3s ease;
    width: 7.5vw;
    height: 7.5vw;
  }

  .like-active {
    opacity: 0;
  }
}
</style>
